import { defineStore } from "pinia";
import type { Artwork } from "~~/types/artwork";
import type { AppUser } from "~~/types/user";

export type SearchType = "artist" | "artwork";

interface SearchStoreState {
  showSearch: boolean;
  searching: boolean;
  moreLoading: boolean;
  searched: boolean;
  hasMore: boolean;
  searchType: SearchType;
  artworks: Artwork[];
  artists: AppUser[];
  page: number;
}

export const useSearchStore = defineStore("SearchStore", {
  state: (): SearchStoreState => ({
    showSearch: false,
    searching: false,
    moreLoading: false,
    searched: false,
    hasMore: false,
    searchType: "artwork",
    artists: [],
    artworks: [],
    page: 1,
  }),
  actions: {
    openSearchModal(): void {
      this.showSearch = true;
      document.body.style.overflow = "hidden";
    },
    closeSearchModal(): void {
      document.body.style.overflow = "auto";
      this.showSearch = false;
    },
    selectSearchType(t: SearchType) {
      if (!t) return;
      this.searchType = t;
      this.page = 1;
      this.hasMore = false;
    },
    async search(search: string, more: boolean = false): Promise<void> {
      const { $api, $i18n } = useNuxtApp()
      if (more) {
        this.moreLoading = true;
      } else {
        this.page = 1;
        this.hasMore = false;
        if (this.searchType === "artist") {
          this.artists = [];
        } else {
          this.artworks = [];
        }
        this.searching = true;
      }
      this.searched = false;
      try {
        const data = await $api<any>("/art/search", {
          method: "GET",
          params: {
            type: this.searchType,
            search,
            page: this.page,
          },
        });

        console.log("data", data);
        const dataResult = data.data;
        console.log("dataResult", dataResult);
        if (this.searchType === "artist") {
          this.artists = [...this.artists, ...dataResult];
        } else {
          this.artworks = [...this.artworks, ...dataResult];
        }
        this.hasMore = data.hasMore || false;
        this.searched = true;
      } catch (error) {
        console.error(error);
        this.searched = false;
      } finally {
        this.searching = false;
      }
    },
    searchMore(q: string) {
      if (this.hasMore) {
        this.page++;
        this.search(q, true);
      }
    },
  },
});
